module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/all-4290e8e2b364397ad5ca2eaeb3f8d925.svg";